import React, {Fragment, memo} from 'react';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import DisplayImage from '../display-image';
import {colors, fontFamily, fontWeight} from '@/styles/tokens';

// Migrated from globals.scss `.brands-label`. Sole owner — no other component/page references this class.
const brandsLabelSx = {
    fontFamily: `${fontFamily.heading} !important`,
    fontSize: '26px !important', // no exact token match — preserved for parity
    fontWeight: `${fontWeight.bold} !important`,
    color: colors.text.primary
} as const;

// Migrated from globals.scss `.brands-img-wrapper`. Sole owner — no other component/page references this class.
const brandsImgWrapperSx = {
    backgroundColor: colors.background.default,
    width: '266px', // no exact token match — preserved for parity
    height: '270px', // no exact token match — preserved for parity
    margin: '0 auto',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px' // no exact token match — preserved for parity
} as const;

// Migrated from globals.scss `.brands-img`. Sole owner — no other component/page references this class.
const brandsImgSx = {
    marginTop: '35px' // no exact token match — preserved for parity
} as const;

const Brands = (props: any) => {
    const {brandsheading, brandsData, className, brandimgclass, brandlabelclass, headingSx} = props;
    return (
        <MUIBox>
            <MUITypography className={`challenge-heading ${className} center`} sx={headingSx}>
                {brandsheading}
            </MUITypography>
            <MUIBox className="divder-wrapper">
                <hr className="divider-line" />
            </MUIBox>
            <MUIGrid container textAlign="center">
                {brandsData?.map((data: any, index: any) => (
                    <Fragment key={index}>
                        <MUIGrid item xs={12} sm={12} md={4} lg={4} className="top-spacing">
                            <MUIBox className="brands-img-wrapper" sx={brandsImgWrapperSx}>
                                <DisplayImage
                                    src={data.img}
                                    alt={data.label}
                                    className={`brands-img ${brandimgclass}-${index + 1}`}
                                    sx={brandsImgSx}
                                />
                                <MUITypography className={`brands-label ${brandlabelclass}-${index + 1}`} sx={brandsLabelSx}>
                                    {data.label}
                                </MUITypography>
                            </MUIBox>
                        </MUIGrid>
                    </Fragment>
                ))}
            </MUIGrid>
        </MUIBox>
    );
};
export default memo(Brands);
